import * as $ from 'jquery';
declare var layer:any;
export class Tree {
    id:number;
    url_get_children: string;
    url_get_tree:string;
    select_div:JQuery;
    input_tree:JQuery;
    topId: number;
    topName: string;
    levelGE:number;//只能显示到这一级，下级不可显示
    data_fields: any = { "name": "name" }; //select option上面额外的属性，data-field-name="abc"
    isTreeLoaded: JQueryDeferred<any>;
    /**
     * id：当前分类的id
     */
    constructor(id:number,url_get_children: string,url_get_tree:string, select_div:JQuery,input_tree:JQuery,data_fields:any={}) {
        this.id=id;
        this.url_get_children = url_get_children;
        this.url_get_tree=url_get_tree;
        this.input_tree=input_tree;
        this.select_div = select_div;
        this.topId = 0;
        this.topName = '';
        this.levelGE=-1;
        this.data_fields = data_fields;
        this.isTreeLoaded = $.Deferred();
    }
    public setTopId(idOrName:any,type='name'){
        let _this=this,dtd=jQuery.Deferred();
        if (type == 'name') {
            this.topName = idOrName;
            $.getJSON(this.url_get_tree, { name: idOrName }, function (node:any) {
                _this.topId=node['id'];
                dtd.resolve();
            });
            
        }else{
            this.topId=idOrName;
            dtd.resolve();
        }
        return dtd;
    }
   
    public setLevelGE(level:number){
        this.levelGE=level;
    }
    onChildLoaded(parent_select:any){}
    onTreeLoaded()
    {
        

    }
    onInputChange(vaule:any) {}

    /**
     * 加载下级select
     * id:要加载此分类的下级
     */
    load_child(id: number, select: any, optionEx = '<option value="">请选择</option>') {
        var THIS = this;
        let dfd=$.Deferred();
        $.getJSON(this.url_get_children, { id: id }, function (trees:any) {
            THIS.gen_child_select(trees, select, optionEx);
            THIS.onChildLoaded(select);
            dfd.resolve();
        });
        return dfd;
    }
    /**
     * 级联分类select改变时
     */
    select_change(select:JQuery) {
        var tree_id:any = select.val();
        if(this.id>0 && tree_id==this.id){
            alert('不能选择自己为上级');
            select.val("");
            return false;
        }
        select.nextAll().remove();
        this.set_tree_id();
        if (tree_id != "") {
            let has_children:string = $('option:selected', select).attr('data-has_children');
            if (has_children != '0' ) {
                if(this.levelGE!=-1){
                    let level=parseInt($('option:selected', select).attr('data-level'));
                    if(this.levelGE<=level){
                        return;
                    }
                }
                this.load_child(tree_id, select);
            }
        }
    }
    /**
     * 获取选中的select的值和文本
     */
     get_selected_branch(selects:any=null) {
         let THIS=this;
        var tree_id:any = 0;
        var text="",level,has_children;
        if(selects==null){
            selects=$('select', this.select_div);
        }
        let $option:any=null;
        $.each(selects, function (i,n) {
            var cat_id = $(n).val();
            if (cat_id != "") {
                tree_id = cat_id;
                $option=$(n).find("option:selected");
                text=$option.text();
                level=$option.attr('data-level');
                has_children=$option.attr('data-has_children');
            } else {
                return {"value":"","text":"",'level':'',has_children:0,tree:THIS,thisOption:$option};
            }
        });
        
        return  {"value":tree_id,"text":text,'level':level,has_children:has_children,tree:THIS,thisOption:$option};
    }
    /**
     * 把级联分类select的值写到input
     */
    set_tree_id() {
        var branch=this.get_selected_branch();
        this.input_tree.val(branch.value);
        this.onInputChange(branch.value)
        return  branch;
    }
    /**
     * 根据一系列tree id来生成select并给select赋值
     * param={ids:[0,1,33],index:0,optionEx:'<option value="">请选择</option>'}
     */

    protected load_trees(param:any) {
        var THIS = this;
        let dfd=$.Deferred();
        var pid = param.ids[param.index];
        $.getJSON(this.url_get_children, { id: pid }, function (trees:any) {
            var select = THIS.gen_child_select(trees);
            param.index++;
            var id = param.ids[param.index];
            select.val(id);
            if (param.index < param.ids.length - 1) {
                THIS.load_trees(param);
            }else{
                dfd.resolve();
            }
            THIS.onChildLoaded(select.prev());
        });
        return dfd;
    }
    /**
     * 生成下级select
     */
    protected gen_child_select(children:any, parent_select:any = null, optionEx = '<option value="">请选择</option>') {
        var THIS=this;
        if (children == null && optionEx==null) return;
        var child_select = $('<select/>');
        if (parent_select == null) {
            child_select.appendTo(this.select_div);
        } else {
            child_select.insertAfter(parent_select);
        }
        if (optionEx != null) $(optionEx).appendTo(child_select);
        $.each(children, function (i, n) {
            let dataProp:any={'data-has_children':n.has_children,'data-level':n.level};
            if(!$.isEmptyObject(THIS.data_fields)){
                $.each(THIS.data_fields,function(name,alias){
                    dataProp['data-field-'+alias]=n[name];
                });
            }
            Util.genSelectOption(n.id,n.text,dataProp).appendTo(child_select);
           // $('<option value="' + n.id + '" data-has_children="' + n.has_children + '">' + n.text + '</option>').appendTo(child_select);
        });
        child_select.change(function () {
           
            THIS.select_change($(this));
        });
        return child_select;
    }
    reload(treeId:any=null) {
        if (treeId == null) {
            treeId = this.input_tree.val();
        }
        this.select_div.empty();
        this.load_tree(treeId);
    }
    /**
     * 入口函数
     * 根据当前tree_id来加载所有select；如果是0，则只加载顶级select，否则，从顶级select一直加载到
     */
    load_tree(tree_id: number = 0) {
        this.isTreeLoaded = $.Deferred();
        var THIS=this;
        if (tree_id == 0) {
            if(this.topId>0){
                tree_id=this.topId
            }
            this.load_child(tree_id, null, '<option value="">顶级</option>').done(function(){
                THIS.input_tree.val(tree_id.toString());
                THIS.onInputChange(tree_id);
                THIS.onTreeLoaded();
                THIS.isTreeLoaded.resolve();
            });
            
        } else if(tree_id==this.topId){
            this.load_child(tree_id, null, '<option value="">顶级</option>').done(function(){
                THIS.input_tree.val(tree_id.toString());
                THIS.onInputChange(tree_id);
                THIS.onTreeLoaded();
                THIS.isTreeLoaded.resolve();
            });
            
        }else{
            $.getJSON(THIS.url_get_tree, { id: tree_id }, function (tree) {
                   let ids =[],tmpIds=[];
                    if(tree.arrparentid!=null || tree.arrparentid!=""){
                        tmpIds=tree.arrparentid.split(',');
                    }
                    if(THIS.topId!=null){
                        let index:any=0;
                        $.each(tmpIds,function(i,v){
                            if(v==THIS.topId){
                                index=i;
                                return false;
                            }
                        });
                        ids=tmpIds.slice(index);
                    }else{
                        ids=tmpIds;
                    }
                    ids.push(tree_id);
                    var param = {
                        ids: ids,
                        index: 0,
                        optionEx: '<option value="">请选择</option>'
                    };
                    THIS.input_tree.val(tree_id.toString());
                    THIS.load_trees(param).done(function(){
                        THIS.onTreeLoaded();
                        THIS.isTreeLoaded.resolve();
                    });
                });
        }
    }
   
}


class Upload {
    dialog: any;
    form:JQuery;
    constructor(dialog:any,dialog_param:any=null,ajax_form_options:any= null) {
        var form:any = $('form', dialog);
        this.form=form;
        var dlg_defalut={
            title: "上传",
            autoOpen: false,
            width: 500,
            height: 300,
            buttons: [
                {
                    text: "上传",
                    click: function () {
                        form.submit();
                        dialog.dialog('close');
                    }
                },
                {
                    text: "取消",
                    click: function () {
                        dialog.dialog('close');
                    }
                }
            ]
        };
        var ajax_form_default={
            // target:        '#output1',   // target element(s) to be updated with server response 
            //   beforeSubmit:  showRequest,  // pre-submit callback 
            success: function (json:any) {
                if (json.status == 0) {
                    //$("#thumb input").val(json.thumb);
                   // $("#thumb img").attr('src', json.thumb);
                   alert(json.thumb);
                } else {
                    alert(json.msg);
                }

            },  // post-submit callback 

            // other available options: 
            //url:       url         // override for form's 'action' attribute 
            //type:      type        // 'get' or 'post', override for form's 'method' attribute 
            dataType: 'json'        // 'xml', 'script', or 'json' (expected server response type) 
            //clearForm: true        // clear all form fields after successful submit 
            //resetForm: true        // reset the form after successful submit 

            // $.ajax options can be used here too, for example: 
            //timeout:   3000 
        };
        if(dialog_param!=null){
            $.extend(dlg_defalut,dialog_param);
        }
        if(ajax_form_options!=null){
            $.extend(ajax_form_default,ajax_form_options);
        }
        this.dialog = dialog;
        dialog.dialog(dlg_defalut);  
        form.ajaxForm(ajax_form_default);
    }
    showDialog() {
        this.dialog.dialog('open');
    }
}


export class Form{
    $form:JQuery;
    values:any;
    constructor($form:JQuery,values:any=null){
        this.$form=$form;
        if(values!=null){
            this.values=values;
            this.setValue(values);
        }
    }
    setValue(values:any) {
        let _this=this;
        $.each(values,function(name:any,value){
            let $input=$(":input[name='"+name+"']",_this.$form);
            if($input.prop('type')=="radio"){
                $(":input[name='"+name+"'][value="+value+"]",_this.$form).prop("checked",true);
            }else if($input.prop('type')=="checkbox"){
                if(!(value instanceof Array)){
                    value=value.split(',');
                }
                $input.val(value);
            }else if(value instanceof Array){
                $input=$(":input[name='"+name+"[]']",_this.$form);
                if($input.length>0){
                    $input.val(value);
                }
            }else {
                $input.val(value);
            }
            
        });
    }
    getValue(){ 
        let values:any={},_this=this;
        $.each($(":input",this.$form),function(){
            let $input=$(this),value:any;
            let name=$input.attr("name");
            if(name in values){
                return ;
            }
            if($input.prop('type')=="radio"){
                value=$(":input[name='"+name+"']:checked",_this.$form).val();
            }else if($input.prop('type')=="checkbox"){
                value=[];
                $(":input[name='"+name+"']:checked",_this.$form).each(function(i,n){
                    value.push($(n).val());
                });
            }else{
                value=$input.val();
            }
            values[name]=value;
        });
        this.values = values;
        return values;
    }
    getFieldValue(fields:any=[]):any{
        let values:any={};
        let _this=this;
        $.each(fields,function(i,n){
            let value=$(":input[name='"+n+"']",_this.$form).val();
            values[n]=value;
        });
        return values;
    }
    JsonData() {
        var o:any = {};
        var a = this.$form.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };
    genSelect(select:JQuery,data:{value:any,text:any},iniOption:string='',selectedValue:any=null){
        select.empty();
        if(iniOption!=''){
            select.append(iniOption);
        }
        $.each(data,function(i,n) {
            let $option=$('<option/>').val(n.value).text(n.text);
            $.each(n,function(k:any,v){
                if(k!='value' && k!='text'){
                    $option.attr('data-'+k,v);
                }
            });
            $option.appendTo(select);
        });
        if(selectedValue!=null){
            select.val(selectedValue);
        }
    }
}

/**
 * UploadFile--文件上传，需要jquery.fileupload.js
 */
class UploadFile {
    fileUploadId:JQuery;//表单file元素id：input[type=file]，上传按钮点击后，激发此控件的click事件
    uploadUrl:string;//上传url

    uploadButton:JQuery;//上传按钮
    urlInput:JQuery;//容器中的input，保存上传文件的url
    constructor(parameters:any) {
        this.fileUploadId=parameters.fileUploadId;
        this.uploadUrl=parameters.uploadUrl;
        this.init();
    }
    //设置参数
    setValues()
    {
    }
    //
    onButtonClick(button:any){ 
        this.uploadButton=$(button);
        this.setValues();
        return $('#'+this.fileUploadId).click();//必须这样$('#'+this.fileUploadId)，才能多次点击上传；否则只有第一次成功；
    }
    
    //文件上传初始化
    private init()
    {
        let THIS=this,fileupload:any=$('#'+this.fileUploadId);
		fileupload.fileupload({
		    url: this.uploadUrl,
	        dataType: 'json',
	        done: function (e:any, data:any) {  
                THIS.callback(e,data);
	        }
	    });   
    }
    
    callback(e:any,data:any)
    {      
    }
    //删除上传的文件
    deleteFile()
    {   
    }
}
/**
 * Helper 助手类
 */
class Helper {
    constructor() {

    }
    //获取字符串长度（中英文）
    getBLen(str:any) {
        if (str == null) return 0;
        if (typeof str != "string") {
            str += "";
        }
        return str.replace(/[^\x00-\xff]/g, "01").length;
    }

    delHtmlTag(str:any) {
        return str.replace(/<[^>]+>/g, "");//去掉所有的html标记
    }
    trim(str:string,ch='')
    {
        if(ch==''){
            str=str.replace(/(^\s*)|(\s*$)/g, "");
        }else{
            while (str.substr(0,1)==ch) {
                str=str.substr(1);
            }
            while (str.substr(str.length-1,1)==ch) {
                str=str.substr(0,str.length-1);
            }
        }
        return str;
    }
    placeholder(nodes:JQuery,placeholder_color:any) {
        if (nodes.length>0 && !this.placeholderSupport()) {   // 判断浏览器是否支持 placeholder
            nodes.focus(function () {
                var input = $(this);
                if (input.val() == input.attr('placeholder')) {
                    input.val('').css('color','');
                }
            }).blur(function () {
                var input = $(this);
                if (input.val() == '' || input.val() == input.attr('placeholder')) {
                    input.val(input.attr('placeholder')).css('color',placeholder_color);
                }
            }).blur();
        };
    }
    placeholderSupport() {
        return 'placeholder' in document.createElement('input');
    }
}

/**
 * Datetime
 */
class Datetime {
    date:Date;
    /**
     * time:1970年至今的秒数
     */
    constructor(time:any) {
        this.date=new Date(time*1000);
    }
    setDate(time:any){
        this.date=new Date(time*1000);
    }
    format(fmt:any,time:any=null)
    {
        var date;
        if(time!=null){
            date=new Date(time*1000);
        }else{
            date=this.date;
        }
        var o:any = {
            "m+": date.getMonth() + 1, //月份 
            "d+": date.getDate(), //日 
            "h+": date.getHours(), //小时 
            "i+": date.getMinutes(), //分 
            "s+": date.getSeconds(), //秒 
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
            "S": this.date.getMilliseconds() //毫秒 
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }
}


export class Util 
{
    static list2Map(list: Array<Array<any>>,key:string) {
        let map:any = {};
        if ($.isArray(list) && list.length > 0) {
            list.forEach(function (ele, index) {
                map[key] = ele;
            });
        }
        return map;
    }
    static toUtf8(str:any) {
    var out, i, len, c;
    out = "";
    len = str.length;
    for (i = 0; i < len; i++) {
        c = str.charCodeAt(i);
        if ((c >= 0x0001) && (c <= 0x007F)) {
            out += str.charAt(i);
        } else if (c > 0x07FF) {
            out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
            out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
        } else {
            out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
        }
    }
    return out;
}
    /**
     * 
     * @param isTrue --function ,必须式可以重复执行的函数
     * @param interval 
     */
    static wait(isTrue:Function,interval=500)
    {
        var timer:any,dtd=jQuery.Deferred();
        timer=setInterval(function(){
            if(isTrue()){
                dtd.resolve();
                clearInterval(timer);
            }
        },interval);
        return dtd;
    }
    /**
     * 格式化数字，保留指定有效数字和小数位
     * 
     * @param num 
     * @param digits 有效数字位数
     * @param decimal 小数位数
     */
    static significant(num:any,digits:number,decimal:number)
	{
		if(isNaN(num) || num=='' || num==null){
			return num;
        }
        num = parseFloat(num);
       /* num=""+num;
        //如果没有小数位，则添加小数位
        var pattern = '^\\d+\\.[\\d]{' + (decimal+1) + '}';
		if(!num.match(/\./)){
			num=num+".0000000000";
        }else if(num.match(pattern)==null){
            num=num+"0000000000";
        }
        var newVal;
		if(parseFloat(num)<1){
            pattern='^0\\.0*[\\d]{1,'+(digits+1)+'}';
        }
        newVal=num.match(pattern);
    
        return newVal.toString();*/

        if (num > 1) {
            return num.toFixed(decimal);
        } else {
            return parseFloat(num.toPrecision(digits)).toFixed(decimal);
        }
    }
    static inArray(value:any, array:any, valueTypeStrict = false) {
        if (valueTypeStrict) {
            return $.inArray(value, array) != -1;
        } else {
            return $.inArray(value, array) != -1 || $.inArray('' + value, array) != -1 || $.inArray(parseInt(value), array) != -1 || $.inArray(parseFloat(value), array) != -1;
        }
    }
    static isEmptyNullUndefined(value: any) {
        return value == '' || value == '[]' || value == null || typeof value == "undefined" ;
    }
    /**
     * ajax获取数据生成select下拉框
     * @param url 
     * @param param 
     * @param $select 
     * @param options 
     */
    static ajaxSelect($select:any,options:any,url:any,param={})
	{
		$.getJSON(url,param,function(data){
			var vFld=options['vFld'],vTxt=options['vTxt'],orgOption=options['orgOption'];
			if(orgOption!=null){
				$(orgOption).appendTo($select);
			}
		    $.each(data,function(i,v){
		    	$('<option value="'+v[vFld]+'">'+v[vTxt]+'</option>').appendTo($select);
		    });
		});
    }
    static genSelectOption(value:any,text:any,props={}):JQuery
    {
        let $option=$('<option value="'+value+'">'+text+'</option>');
        if(!$.isEmptyObject(props)){
            $.each(props,function(k,v){
                $option.attr(k,v);
            })
        }
        return $option;
    }
    static msg(msg:string){
        layer.msg(msg);
    }
    static addOptionsToSelect(source: Array<{ value: string, text: string, prop?: {} }>, $select:any, defaultOption = '<option vlue="">请选择</option>') {
        let _this = this;
        if (defaultOption != '') {
            $(defaultOption).appendTo($select);
        }
        $.each(source, function (i, opt) {
            _this.genSelectOption(opt.value, opt.text).appendTo($select);
        });
    }
    static insertHtmlAtCaret(html:string) {
        var sel, range;
        if (window.getSelection) {
            sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                range = sel.getRangeAt(0);
                range.deleteContents();
                var el = document.createElement("div");
                el.innerHTML = html;
                var frag = document.createDocumentFragment(), node, lastNode;
                while ((node = el.firstChild)) {
                    lastNode = frag.appendChild(node);
                }
                range.insertNode(frag);
                if (lastNode) {
                    range = range.cloneRange();
                    range.setStartAfter(lastNode);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            }
        } else{

            let doc:any=document,selection:any=doc.selection;
            if (selection && selection.type != "Control") {
            // IE < 9
                selection.createRange().pasteHTML(html);
            }
        }
    }

    /**
     * 公式是否合法
     
         * 假如待选变量：  ID,NUM,TOTAL，AVL TEST
         * 正确的公式例子：ID*NUM+(TOTAL/AVL)*0.5 
         * 错误的公式例子：ID**|0.5
         * // 测试
        var fields = {
            'ID': 1,
            'TOTAL': 1,
            'AVL' : 1,
            'NUM' : 1
        };
        // 提交到服务器端的字符串不应该包含空白符，或者应该禁止用户输入空白符
        alert( fn('ID*NUM+(TOTAL/AVL)*0.5', fields) );
         */

    static isFormulaLegal(str: string, fieldMap: {[value:string]:string})
    {
        fieldMap['ceil'] = '';
        fieldMap['floor'] = '';
        // TODO: 如何处理=？
            // 剔除空白符
            str = str.replace(/\s/g, '');
            
            // 错误情况，空字符串
        if ("" === str) {
            return { status: Constants.STATUS_FAILED, info:'空字符串' };
        }
            
            // 错误情况，运算符连续

            /*if( /[\+\-\*\/]{2,}/.test(str) ){
                return false;
            }*/
            if( /[\+\-\*\/]{2,}/.test(str) ){
                return { status: Constants.STATUS_FAILED, info: '运算符连续' };
            }

            
            // 空括号
            if(/\(\)/.test(str)){
                return { status: Constants.STATUS_FAILED, info: '空括号' };
            }
            
            // 错误情况，括号不配对
            var stack = [];
            for(var i = 0, item; i < str.length; i++){
                item = str.charAt(i);
                if('(' === item){
                    stack.push('(');
                }else if(')' === item){
                    if(stack.length > 0){
                        stack.pop();
                    }else{
                        return { status: Constants.STATUS_FAILED, info: '括号不配对' };
                    }
                }
            }
            if(0 !== stack.length){
                return { status: Constants.STATUS_FAILED, info: '括号不配对' };
            }
           
            // 错误情况，(后面是运算符 
            if(/\([\+\*\/\>\<\=\&\|]/.test(str)){
                return { status: Constants.STATUS_FAILED, info: '(后面是运算符' };
            }
            
            // 错误情况，)前面是运算符
            if(/[\+\-\*\/\>\<\=\&\|]\)/.test(str)){
                return { status: Constants.STATUS_FAILED, info: ') 前面是运算符' };
            }
            
        // 错误情况，(前面不是运算符
        if (/[^\+\-\*\/\(\>\<\=\&\|]\(/.test(str.replace(/ceil\(/g, '(').replace(/floor\(/g,'('))) {
            return { status: Constants.STATUS_FAILED, info: '(前面不是运算符' };
         }
            
            // 错误情况，)后面不是运算符
        if (/\)[^\+\-\*\/\)\>\<\=\&\|]/.test(str)){
            return { status: Constants.STATUS_FAILED, info: ')后面不是运算符' };
        }
            
            // 错误情况，变量没有来自“待选公式变量”
       // var tmpStr = str.replace(/[\(\)\+\-\*\/]{1,}/g, '`');

        var tmpStr = str.replace(/[\(\)\+\-\*\/\>\<\=\&\|]{1,}/g, '`');
            tmpStr = tmpStr.replace(/``/g, '`');
            var array = tmpStr.split('`');
            for(var i = 0, item; i < array.length; i++){
                item = array[i];
               
               /* if( /[A-Z]/i.test(item) && 'undefined' === typeof(obj[item]) ){
                    return false;
                }*/
                if (item == '') {
                    continue;
                }
                if (!$.isNumeric(item) && 'undefined' === typeof (fieldMap[item])) {
                    return { status: Constants.STATUS_FAILED, info: '非法变量或函数' };
                }
            }

        return { status: Constants.STATUS_SUCCESS, info: '成功' };
    }
    

}
